const InstagramWallBaseURL =
  "https://api.flockler.com/v1/sites/22369/sections/64381/articles?count=12";
const InstagramWallSelectors = {
  article: 'a',
  image: 'img'
}

class InstagramWall extends HTMLElement {
  constructor() {
    super();

    this.articleTemplate = new DOMParser().parseFromString(this.querySelector("template").innerHTML, "text/html").querySelector(InstagramWallSelectors.article);

    this.fetchContent();
  }

  fetchContent(param) {
    let url = new URL(InstagramWallBaseURL);
    if (param) {
      url.searchParams.append(param.key, param.value);
    }

    fetch(url)
      .then(response => response.json())
      .then(json => {

        if (json.articles.length == 0) {
          return
        }

        requestAnimationFrame(() => {
          this.querySelectorAll(InstagramWallSelectors.article)
            .forEach(el => {
              el.remove();
            })

          json.articles.forEach((article, index) => {
            let template = this.articleTemplate.cloneNode(true);
            let link = template;
            let img = template.querySelector(InstagramWallSelectors.image);
            
            link.style.setProperty("--index", index);
            link.href = article.url;
            link.dataset.id = article.id;
            img.setAttribute("src", article.cover_url);
  
            this.append(template);
          });
  
          this.articles = Array.from(this.querySelectorAll(InstagramWallSelectors.article));
        })
      })
  }

  fetchOlder() {
    let article = this.articles[this.articles.length - 1];
    this.fetchContent({ key: "max_id", value: article.dataset.id });
  }

  fetchNewer() {
    let article = this.articles[0];
    this.fetchContent({ key: "since_id", value: article.dataset.id });
  }
}

customElements.define('instagram-wall', InstagramWall);

class InstagramWallPager extends HTMLElement {
  constructor() {
    super();

    this.wall = this.closest('instagram-wall') || document.querySelector(this.getAttribute('wall'));
    this.direction = this.hasAttribute('next') ? "next" : "previous";
    this.isNext = (this.direction == 'next');
    this.isPrevious = (this.direction == 'previous');

    this.addEventListener('click', this.onClick);
  }

  onClick(ev) {
    ev.preventDefault();

    if (this.isNext) {
      this.wall.fetchOlder()
    }

    if (this.isPrevious) {
      this.wall.fetchNewer()
    }
  }
}

customElements.define('instagram-wall-pager', InstagramWallPager);